google.maps.visualRefresh = true;
function initialize() {
    var montrealLocation = document.querySelector("#montreal-location");
    var brossardLocation = document.querySelector("#brossard-location");
    var longueuilLocation = document.querySelector("#longueuil-location");
    var myLatlngBrossard = new google.maps.LatLng(brossardLocation.dataset.lat, brossardLocation.dataset.lng);
    var myLatlngLongueuil = new google.maps.LatLng(longueuilLocation.dataset.lat, longueuilLocation.dataset.lng);
    var myLatlngCenter = new google.maps.LatLng(45.601662, -73.512764);
    var myLatlngMontreal = new google.maps.LatLng(montrealLocation.dataset.lat, montrealLocation.dataset.lng); //var myLatlngMontreal = new google.maps.LatLng(45.612291, -73.578055);
    var mapOptions = {
        center: myLatlngCenter,
        zoom: 11,
        scrollwheel: false,
        mapTypeControl: true,
        mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            position: google.maps.ControlPosition.LEFT_BOTTOM
        },
        zoomControl: true,
        zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        scaleControl: false,
        streetViewControl: false,
        styles: [{ "featureType": "all", "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 }] }, {
            "featureType": "all", "elementType": "labels.text.stroke",
            "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 }]
        }, { "featureType": "all", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, {
            "featureType": "administrative",
            "elementType": "all", "stylers": [{ "visibility": "off" }]
        }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#fefefe" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "lightness": 20 }, { "color": "#ececec" }] },
        { "featureType": "landscape.man_made", "elementType": "all", "stylers": [{ "visibility": "on" }, { "color": "#f0f0ef" }] }, {
            "featureType": "landscape.man_made", "elementType": "geometry.fill", "stylers": [{ "visibility": "on" },
            { "color": "#f0f0ef" }]
        }, { "featureType": "landscape.man_made", "elementType": "geometry.stroke", "stylers": [{ "visibility": "on" }, { "color": "#d4d4d4" }] },
        { "featureType": "landscape.natural", "elementType": "all", "stylers": [{ "visibility": "on" }, { "color": "#ececec" }] }, { "featureType": "poi", "elementType": "all", "stylers": [{ "visibility": "on" }] },
        { "featureType": "poi", "elementType": "geometry", "stylers": [{ "lightness": 21 }, { "visibility": "off" }] }, { "featureType": "poi", "elementType": "geometry.fill", "stylers": [{ "visibility": "on" }, { "color": "#d4d4d4" }] },
        { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#303030" }] }, { "featureType": "poi", "elementType": "labels.icon", "stylers": [{ "saturation": "-100" }] },
        { "featureType": "poi.attraction", "elementType": "all", "stylers": [{ "visibility": "on" }] }, { "featureType": "poi.business", "elementType": "all", "stylers": [{ "visibility": "on" }] },
        { "featureType": "poi.government", "elementType": "all", "stylers": [{ "visibility": "on" }] }, { "featureType": "poi.medical", "elementType": "all", "stylers": [{ "visibility": "on" }] },
        { "featureType": "poi.park", "elementType": "all", "stylers": [{ "visibility": "on" }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#dedede" }, { "lightness": 21 }] },
        { "featureType": "poi.place_of_worship", "elementType": "all", "stylers": [{ "visibility": "on" }] }, { "featureType": "poi.school", "elementType": "all", "stylers": [{ "visibility": "on" }] },
        { "featureType": "poi.school", "elementType": "geometry.stroke", "stylers": [{ "lightness": "-61" }, { "gamma": "0.00" }, { "visibility": "off" }] },
        { "featureType": "poi.sports_complex", "elementType": "all", "stylers": [{ "visibility": "on" }] }, {
            "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" },
            { "lightness": 17 }]
        }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 }] },
        { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 18 }] }, {
            "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#ffffff" },
            { "lightness": 16 }]
        }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#f2f2f2" }, { "lightness": 19 }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#dadada" }, { "lightness": 17 }] }]
    };
    var bounds = new google.maps.LatLngBounds();
     bounds.extend(myLatlngMontreal);
  bounds.extend(myLatlngBrossard);
  bounds.extend(myLatlngLongueuil);
  
    var map = new google.maps.Map($('.map-canvas')[0], mapOptions);
    /* MONTREAL */
    var markerMontreal = new google.maps.Marker({
        position: myLatlngMontreal,
        map: map,
        icon: 'images/map_pin2.png',
        url: montrealLocation.dataset.url
    });
   var markerLongueuil = new google.maps.Marker({
    position: myLatlngLongueuil,
    map: map,
    icon: 'images/map_pin2.png',
    url: longueuilLocation.dataset.url
  });
  
  var markerBrossard = new google.maps.Marker({
    position: myLatlngBrossard,
    map: map,
    icon: 'images/map_pin2.png',
    url: brossardLocation.dataset.url
  });

   google.maps.event.addListener(markerLongueuil, 'click', function () {
    window.open(this.url, '_blank');
  });
  google.maps.event.addListener(markerBrossard, 'click', function () {
    window.open(this.url, '_blank');
  });
    google.maps.event.addListener(markerMontreal, 'click', function () {
        window.open(this.url, '_blank');
    });
    map.fitBounds(bounds);
}
google.maps.event.addDomListener(window, 'load', initialize);
